import axios from 'axios';
const apiUrl = process.env.VUE_APP_API_URL_NEDBANK;

// const login = async (username, password) => {
//   try {
//     const response = await axios.post(
//       '/api/home/Login',
//       {
//         username: username,
//         password: password,
//         appkey: '',
//         method: 'POST',
//       },
//       {
//         headers: {
//           'Content-Type': 'application/json',
//           'Cache-Control': 'no-cache',
//         },
//         withCredentials: true,
//       }
//     );

//     if (response.status === 200 && response.data && response.data.data.token) {
      
//       return {
        
//         success: true,
//         data: response.data.data
//       };
//     } else {
//       return { success: false, message: 'Invalid credentials' };
//     }
//   } catch (error) {
//     console.error('Error during API call:', error);
//     if (error.response) {
//       return { success: false, message: `Error : ${error.response.data.message || 'An error occurred.'}` };
//     } else if (error.request) {
//       return { success: false, message: 'No response received from the server. Please check your network connection.' };
//     } else {
//       return { success: false, message: 'An error occurred while trying to log in. Please try again.' };
//     }
//   }
// };


// const fetchTransactions = async (params) => {
//   try {
//     const apiUrl = "/api/deposite/search";

//     const response = await axios.get(`${apiUrl}?${params.toString()}`, {
//       headers: {
//         "Content-Type": "application/json",
//       },
//       withCredentials: true,  // Si necesitas enviar credenciales
//     });

//     if (response.status === 200 && response.data?.data?.list) {
//       //console.log("API Response:", response.data);
      
//       // Asignar las transacciones y filtrar si es necesario
//       // this.transactions = response.data.data.list;
//       // this.filterTransactionsByTodayDate();

//       // Retorna los datos obtenidos de la API
//       return {
//         success: true,
//         data: response.data.data.list,
//         totalPages: response.data.data.totalPages,
//         count: response.data.data.count,
//         nroPage: response.data.data.nroPage,
//         nextPage: response.data.data.nextPage,
//       };
//     } else {
//       console.error("Invalid response", response.data);
      
//       // Retorna el error de la respuesta
//       return {
//         success: false,
//         message: "Invalid response",
//       };
//     }
//   } catch (error) {
//     console.error("Error fetching transactions!", error);

//     // Manejo de error de servidor
//     if (error.response) {
//       console.error("Response Error:", error.response.data);
//       return {
//         success: false,
//         message: error.response.data.message || 'An error occurred while fetching transactions.',
//       };
//     } 
//     // No hubo respuesta del servidor
//     else if (error.request) {
//       console.error("No response received from the server.");
//       return {
//         success: false,
//         message: 'No response received from the server. Please check your network connection.',
//       };
//     } 
//     // Error en la configuración de la solicitud
//     else {
//       console.error("Error during request setup:", error.message);
//       return {
//         success: false,
//         message: 'An error occurred while trying to fetch transactions. Please try again.',
//       };
//     }
//   }
// };

const createDeposit = async (json) => {
  try {

    // Hacer la solicitud POST
    const response = await axios.post(`${apiUrl}/api/nedbank/create`, json, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // Extraer el código de error, si es un número


    // Verificar si el código de error está en la lista de códigos de error
    if (response.status === 200 && response.data ) {
      // window.location.reload();
      console.log(response.data.data);
      return   {
        success: true,
        message: 'Deposit created successfully',
        data: response.data.data
      };  // Retorna el éxito
    }

  } catch (error) {
    // Manejo de errores
    console.error('There was an error!', error);
    if (error.response) {
      console.error("Response Error:", error.response.data);
      return {
        success: false,
        message: error.response.data.message || 'An error occurred while fetching transactions.',
      };
    } 
    // No hubo respuesta del servidor
    else if (error.request) {
      console.error("No response received from the server.");
      return {
        success: false,
        message: 'No response received from the server. Please check your network connection.',
      };
    } 
    // Error en la configuración de la solicitud
    else {
      console.error("Error during request setup:", error.message);
      return {
        success: false,
        message: 'An error occurred while trying to fetch transactions. Please try again.',
      };
    }
  } 
};

const processDeposit = async (json) => {

  console.log(json);

  try {

    // Hacer la solicitud POST
    const response = await axios.post(`${apiUrl}/api/nedbank/executeDeposit`, json, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // Extraer el código de error, si es un número


    // Verificar si el código de error está en la lista de códigos de error
    if (response.status === 200 && response.data ) {
      // window.location.reload();
      console.log(response.data.data);
      return   {
        success: true,
        message: 'Deposit created successfully',
        data: response.data.data
      };  // Retorna el éxito
    }

  } catch (error) {
    // Manejo de errores
    console.error('There was an error!', error);
    if (error.response) {
      console.error("Response Error:", error.response.data);
      return {
        success: false,
        message: error.response.data.message || 'An error occurred while fetching transactions.',
      };
    } 
    // No hubo respuesta del servidor
    else if (error.request) {
      console.error("No response received from the server.");
      return {
        success: false,
        message: 'No response received from the server. Please check your network connection.',
      };
    } 
    // Error en la configuración de la solicitud
    else {
      console.error("Error during request setup:", error.message);
      return {
        success: false,
        message: 'An error occurred while trying to fetch transactions. Please try again.',
      };
    }
  }

};

// const selectDivision = async (user_id) =>{
//   try{
//     const response = await axios.post(
//       '/api/home/getDivision',
//       {
//         user_id: user_id,
//         method: 'POST',
//       },
//       {
//         headers: {
//           'Content-Type': 'application/json',
//           'Cache-Control': 'no-cache',
//         },
//       }
//     );
//     //console.log(response);
//     if (response.status === 200 && response.data && response.data.data) {
//       //console.log(response.data.data);
//         return {
//           success: true,
//           data: response.data.data
//         };
//     }else{
//       return { success: false, message: 'Invalid user ID' };
//     }
//   }catch (error) {
//     console.error('Error during API call:', error);
//     if (error.response) {
//       return { success: false, message: `Error : ${error.response.data.message || 'An error occurred.'}` };
//     } else if (error.request) {
//       return { success: false, message: 'No response received from the server. Please check your network connection.' };
//     } else {
//       return { success: false, message: 'An error occurred while trying to log in. Please try again.' };
//     }
//   }
// };

export default {
  createDeposit,
  processDeposit,

};